import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, Check, ArrowRight } from "lucide-react";
import { api, resolveImage } from "@/lib/api";
import { PageHeader, TrustStrip, SectionHeading } from "@/components/site/shared";
import { QuoteForm } from "@/components/site/QuoteForm";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { useContent } from "@/lib/ContentContext";

const NEEDS = ["Driveways & concrete", "Pool decks & patios", "Paver sealing", "House soft washing", "Walkways & side entrances", "Algae, mold & grime removal"];

export default function Residential() {
  const { content } = useContent();
  const [projects, setProjects] = useState([]);
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/projects?property_type=residential").then((r) => setProjects(r.data)).catch(() => {});
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);
  const ba = projects.filter((p) => p.before_image && p.after_image)[0];

  return (
    <div>
      <PageHeader overline="For Homeowners" title="Residential Exterior Cleaning"
        subtitle={content.residential_intro} />
      <section className="py-8 bg-[var(--bg-light)]"><div className="max-w-7xl mx-auto px-4"><TrustStrip /></div></section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-[1fr_440px] gap-12">
          <div>
            <SectionHeading overline="Common Needs" title="What We Clean Around Your Home" />
            <div className="grid sm:grid-cols-2 gap-3">
              {NEEDS.map((n) => <div key={n} className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-4 py-3 card-shadow"><Check className="w-5 h-5 text-[var(--aqua)]" /> {n}</div>)}
            </div>

            {ba && (
              <div className="mt-10">
                <h3 className="font-head font-bold text-2xl text-[var(--navy)] uppercase mb-4">Before & After</h3>
                <div className="aspect-[4/3] max-w-xl"><BeforeAfter before={ba.before_image} after={ba.after_image} alt={ba.title} /></div>
              </div>
            )}

            <div className="mt-10">
              <h3 className="font-head font-bold text-2xl text-[var(--navy)] uppercase mb-2">How Quote Requests Work</h3>
              <ol className="space-y-3 mt-4">
                {["Send your request with photos", "We review the details", "We follow up to confirm scope and timing"].map((t, i) => (
                  <li key={i} className="flex gap-3"><span className="shrink-0 h-7 w-7 rounded-full bg-[var(--action)] text-white text-sm font-bold flex items-center justify-center">{i + 1}</span><span className="text-[var(--text-muted)] pt-0.5">{t}</span></li>
                ))}
              </ol>
            </div>
          </div>

          <div className="lg:sticky lg:top-24 h-fit bg-white border border-gray-100 rounded-2xl card-shadow p-6">
            <h3 className="font-head font-bold text-xl text-[var(--navy)] uppercase mb-4">Get Your Free Home Quote</h3>
            <QuoteForm variant="general" source="residential_page" />
          </div>
        </div>
      </section>
    </div>
  );
}
